"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageLink = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var ImageLink = function ImageLink(props) {
  var className = props.className,
      width = props.width,
      sizeLoading = props.sizeLoading,
      colorLoading = props.colorLoading,
      src = props.src,
      componentDefault = props.componentDefault;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      imgLoad = _useState2[0],
      setImgLoad = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];
  /* solo para hacer pruebas en modo dev
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []); */


  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    className: className,
    width: width,
    children: [src && (imgLoad === undefined || loading) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerLoading, {
      className: "container-loading",
      sizeLoading: sizeLoading,
      colorLoading: colorLoading,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFontawesome.FontAwesomeIcon, {
        className: "icon",
        pulse: true,
        icon: _freeSolidSvgIcons.faSpinner
      })
    }), (!src || imgLoad === false && !loading) && componentDefault, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerLink, {
      className: "container-img",
      show: imgLoad === true && !loading,
      href: src,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: "img",
        src: src,
        onLoad: function onLoad(event) {
          setImgLoad(true);
        },
        onError: function onError(event) {
          setImgLoad(false);
        }
      })
    })]
  });
};

exports.ImageLink = ImageLink;